import { fetchRegisterOrAuthorizeUser } from '../../repositories/users/v2/register-or-authorize-user';
import { transform400, transform200 } from './transformRegisterOrAutorizeResonse';
export function registerOrAuthorizeUser(httpApi, parameters) {
  return fetchRegisterOrAuthorizeUser({
    httpApi: httpApi,
    parameters: parameters,
    mappers: {
      200: transform200,
      400: transform400
    },
    config: {
      requestConfig: {
        headers: [['Content-Type', 'application/json']],
        withCredentials: true
      }
    }
  });
}